export default __webpack_public_path__ + "static/banner-4-9a47391bab7ea45548ced1f6fe6e436f.jpg";